import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Progress } from "@/components/ui/progress";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/cast/Common";
import { AIHelper } from "@/components/cast/AIHelper";
import { DevotionPlans } from "@/components/cast/DevotionPlans";
import { NotesPanel } from "@/components/cast/NotesPanel";

const CATS = [{ k: "all", l: "All" }, { k: "topic", l: "By topic" }, { k: "character", l: "By character" }, { k: "book", l: "By book" }];

function Tracks() {
  const [mods, setMods] = useState<any[]>([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/modules").then((r) => setMods(r.data)); }, []);
  const shown = cat === "all" ? mods : mods.filter((m) => m.category === cat);
  return (
    <div>
      <div className="mb-6 flex flex-wrap gap-2">
        {CATS.map((c) => <button key={c.k} data-testid={`track-filter-${c.k}`} onClick={() => setCat(c.k)} className={`rounded-full border px-4 py-1.5 text-sm font-semibold ${cat === c.k ? "border-[#1E293B] bg-[#1E293B] text-white" : "border-[#E2DBCE] bg-white text-slate-700"}`}>{c.l}</button>)}
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        {shown.map((m) => (
          <Link key={m.id} to={`/deep-water/${m.id}`} data-testid={`module-card-${m.id}`} className="group flex overflow-hidden rounded-2xl border border-[#E2DBCE] bg-white transition-all hover:-translate-y-0.5 hover:shadow-lg">
            <img src={m.image} alt="" className="w-32 object-cover sm:w-40" />
            <div className="flex-1 p-5">
              <p className="eyebrow">{m.category}</p>
              <h3 className="mt-1 font-display text-2xl font-semibold text-slate-900">{m.title}</h3>
              <p className="mt-1 text-sm text-slate-600">{m.summary}</p>
              <Progress value={(m.completed.length / m.lesson_count) * 100} className="mt-4 h-1.5" />
              <p className="mt-1.5 text-xs text-slate-500">{m.completed.length}/{m.lesson_count} lessons</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default function DeepWater() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "tracks";
  return (
    <div>
      <PageHeader metaphor="Deep Water" label="Bible Study" title="Go a little deeper." subtitle="Guided study tracks, a scripture-cited study helper, personal devotion plans, and your study log." />
      <Link to="/deep-dive" data-testid="deep-dive-link" className="mb-4 flex items-center justify-between gap-4 rounded-2xl border border-[#E2DBCE] bg-[#FBF3E4] p-5 transition-transform hover:-translate-y-0.5">
        <span><span className="block font-display text-2xl font-semibold text-slate-900">Deep Dive Bible</span><span className="text-sm text-slate-600">Every chapter, colour highlights, day and night reading, narration and a Study Guide · Cast Plus</span></span>
        <span className="rounded-full bg-[#1E293B] px-4 py-2 text-sm font-semibold text-white">Open</span>
      </Link>
      <Link to="/plans" data-testid="deep-plans-link" className="mb-8 flex items-center justify-between gap-4 rounded-2xl bg-[#1E293B] p-5 text-amber-50 transition-transform hover:-translate-y-0.5">
        <span><span className="block font-display text-2xl font-semibold">Daily reading plans</span><span className="text-sm text-amber-100/80">Psalms in 30 days, the Life of Jesus in 40 days, and more · Cast Plus</span></span>
        <span className="rounded-full bg-amber-300 px-4 py-2 text-sm font-semibold text-amber-950">Explore</span>
      </Link>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="mb-8 h-auto flex-wrap bg-[#F3ECE0] p-1">
          <TabsTrigger value="tracks" data-testid="tab-tracks" className="px-4 py-2">Study tracks</TabsTrigger>
          <TabsTrigger value="ask" data-testid="tab-ask" className="px-4 py-2">Ask the helper</TabsTrigger>
          <TabsTrigger value="plans" data-testid="tab-plans" className="px-4 py-2">Devotion plans</TabsTrigger>
          <TabsTrigger value="notes" data-testid="tab-notes" className="px-4 py-2">My notes</TabsTrigger>
        </TabsList>
        <TabsContent value="tracks"><Tracks /></TabsContent>
        <TabsContent value="ask"><AIHelper initial={params.get("q") || ""} /></TabsContent>
        <TabsContent value="plans"><DevotionPlans /></TabsContent>
        <TabsContent value="notes"><NotesPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
